import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { CurrencyPipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-detail-demande-refusee',
    templateUrl: './detail-demande-refusee.component.html',
    styleUrls: ['./detail-demande-refusee.component.scss'],
    imports: [MatIconButton, MatTooltip, MatDialogClose, MatIcon, CurrencyPipe, DatePipe]
})
export class DetailDemandeRefuseeComponent implements OnInit {
  public trancheSource: any = {};
  public trancheCible: any = {};

  public natureAnalytiqueSource: any = {};
  public natureAnalytiqueCible: any = {};

  public projetSource: any = {};
  public projetCible: any = {};

  public commentaire: string = '';
  public montant: number = 0;
  public motifRefus: string = '';
  public dateRefus: string = '';

  constructor(
    private dialog: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data.virementInterne) {
      if (data.virementInterne.ligneBudgetCible) {
        this.projetCible = data.virementInterne.ligneBudgetCible.projet;
        this.natureAnalytiqueCible = data.virementInterne.ligneBudgetCible.natureAnalytique;
        this.trancheCible = data.virementInterne.ligneBudgetCible.tranche;
      }

      if (data.virementInterne.ligneBudgetSource) {
        this.projetSource = data.virementInterne.ligneBudgetSource.projet;
        this.natureAnalytiqueSource = data.virementInterne.ligneBudgetSource.natureAnalytique;
        this.trancheSource = data.virementInterne.ligneBudgetSource.tranche;
      }

      this.montant = data.virementInterne?.montant;
      this.commentaire = data.virementInterne?.description;
      this.motifRefus = data.virementInterne?.motifRefus;
      this.dateRefus = data.virementInterne?.dateRefus;
    }
  }

  ngOnInit(): void {}
}
